import React from 'react'
import { useEffect, useState } from 'react'
import SnackMsg from '../components/Childs/SnackMsg'
import Steps from '../components/Childs/Steps'
import IntegrationStepOne from '../components/IntegrationHelpers/IntegrationStepOne'
import { checkMappedFields, handleInput, refreshOrganizations } from '../components/ZohoInventoryCommonFunc'
import { handleAuthorize, setGrantTokenResponse } from '../components/IntegrationHelpers/IntegrationHelpers'
import ZohoInventoryIntegLayout from '../components/ZohoInventoryIntegLayout'
import bitsFetch from '../components/Childs/bitsFetch'
import TableCheckBox from '../components/Childs/TableCheckBox'
import LoaderSm from '../components/Childs/LoaderSm'

function ZohoInventory({ wcInventoryConf, setWcInventoryConf, isAuthorized, setisAuthorized, checkingPrevInteg }) {
  const [snack, setSnackbar] = useState({ show: false })
  const [step, setstep] = useState(1)
  const [isLoading, setisLoading] = useState(false)
  const [saveBtn, setSaveBtn] = useState({ saving: false, saved: false })
  const [error, setError] = useState({ dataCenter: '', clientId: '', clientSecret: '' })
  const scopes = 'ZohoInventory.FullAccess.all'
  
  const nextPage = val => {
    setstep(val)
    document.querySelector('.btcd-s-wrp').scrollTop = 0
    if (!wcInventoryConf?.default?.organizations) {
      refreshOrganizations(wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar)
    }
  }
  useEffect(() => {
    window.opener && setGrantTokenResponse()

    if (checkingPrevInteg) {
      setSnackbar({ show: true, msg: 'Checking for previous integration settings...', timeout: 456723452345 })
    }
    if (!checkingPrevInteg) {
      setSnackbar({ show: false })
    }
  }, [checkingPrevInteg])

  useEffect(() => {
    if (saveBtn.saved) {
      setTimeout(() => {
        setSaveBtn({ saving: false, saved: false })
      }, 3000)
    }
  }, [saveBtn.saved])

  const saveInteg = () => {
    if (checkMappedFields(wcInventoryConf)) {
      setSaveBtn({ saving: true, saved: false })
      bitsFetch({ wcInventoryConf }, wcInventoryConf?.newInteg ? 'bit_add_integration_data' : 'bit_save_integration_data')
        .then(result => {
          delete wcInventoryConf.newInteg
          setWcInventoryConf({ ...wcInventoryConf })
          setSnackbar({ show: true, msg: result.data })
          if (result.success) {
            setSaveBtn({ saving: false, saved: true })
          }
          else {
            setSaveBtn({ saving: false, saved: true })
          }

        })
        .catch(_ => {
          setSnackbar({ show: true, msg: 'Something went wrong. Please try again.' })
          setSaveBtn({ saving: false, saved: false })
        })
    } else {
      setSnackbar({ show: true, msg: 'Please map Zoho Required field to save the integration' })
    }
  }

  const toggleIntegration = () => {
    setWcInventoryConf(oldConf => ({ ...oldConf, enabled: !oldConf.enabled }))
  }

  return (
    <div className="btcd-s-wrp">
      <SnackMsg snack={snack} setSnackbar={setSnackbar} />

      <TableCheckBox title="Enable Integration" checked={!('enabled' in wcInventoryConf) || wcInventoryConf.enabled || false} onChange={toggleIntegration} />

      <div className='pos-rel'>
        {(('enabled' in wcInventoryConf && !wcInventoryConf.enabled) || checkingPrevInteg) && (
          <div className="pro-blur flx w-10"></div>
        )}
        <div className="txt-center w-9 mt-2"><Steps step={2} active={step} /></div>

        <div className="flx">
          <div className="w-9 txt-center mt-4">
            <b className="f-lg">Zoho Inventory</b>
            <div>Integration Settings</div>
          </div>
        </div>

        {step === 1 && (
          <IntegrationStepOne
            step={step}
            confTmp={wcInventoryConf}
            handleInput={(e) => handleInput(e, wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar, true, error, setError)}
            error={error}
            setSnackbar={setSnackbar}
            handleAuthorize={() => handleAuthorize(scopes, wcInventoryConf, setWcInventoryConf, setError, setisAuthorized, setisLoading, setSnackbar)}
            isLoading={isLoading}
            isAuthorized={isAuthorized}
            nextPage={nextPage}
          />
        )}

        <div className="btcd-stp-page" style={{ width: step === 2 && 900, minHeight: step === 2 && 650, height: step === 2 && '100%' }}>
          <ZohoInventoryIntegLayout
            handleInput={(e) => handleInput(e, wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar)}
            wcInventoryConf={wcInventoryConf}
            setWcInventoryConf={setWcInventoryConf}
            isLoading={isLoading}
            setisLoading={setisLoading}
            setSnackbar={setSnackbar}
          />
        </div>
      </div>
      {(step === 2 || ('enabled' in wcInventoryConf && !wcInventoryConf.enabled)) && (
        <button
          onClick={saveInteg}
          className="btn btcd-btn-lg green sh-sm flx"
          type="button"
          disabled={saveBtn.saving || saveBtn.saved}
        >
          Save{saveBtn.saved && 'd'}
          {saveBtn.saving && <LoaderSm size={20} clr="#022217" className="ml-2" />}
          <div className="btcd-icn icn-arrow_back rev-icn d-in-b" />
        </button>
      )}
    </div>
  )
}

export default ZohoInventory
